import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Localitate, LocalitateUpdate } from './localitati.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocalitatiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getLocalitatiUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.getLocalitati;
    private storeLocalitatiUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.storeLocalitate;
    private updateLocalitatiUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.updateLocalitati;
    private deleteLocalitateUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.deleteLocalitate;
    private getLocalitatiPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.getLocalitatiPublic;
    private getLocalitatiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.getLocalitatiActive;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.changeStatusLocalitatiActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.localitati.changeStatusLocalitatiPublic;

    constructor(private http: HttpClient) { }

    addLocalitate(tara: Localitate) {
        return this.http.post(this.storeLocalitatiUrl, tara, this.httpOptions);
    }

    updateLocalitate(tara: LocalitateUpdate) {
        return this.http.put(this.updateLocalitatiUrl, tara, this.httpOptions);
    }

    deleteLocalitate(id: number) {
        return this.http.delete(this.deleteLocalitateUrl + id);
    }

    getLocalitati(judet?: number, name?: string, country?: number): Observable<any> {
        let params: any = {};

        if (judet !== undefined && judet !== -1) {
            params.id_judet = judet;
        }

        if (country !== undefined && country !== -1) {
            params.id_country = country;
        }

        if (name) {
            params.name = name;
        }

        return this.http.get(this.getLocalitatiUrl, {
            ...this.httpOptions,
            params: params
        });
    }

    getLocalitatiActive(judet?: number, name?: string, country?: number): Observable<any> {
        let params: any = {};

        if (judet !== undefined && judet !== -1) {
            params.id_judet = judet;
        }

        if (country !== undefined && country !== -1) {
            params.id_country = country;
        }

        if (name) {
            params.name = name;
        }

        return this.http.get(this.getLocalitatiActiveUrl, {
            ...this.httpOptions,
            params: params
        });
    }


    getLocalitatiPublic() {
        return this.http.get(this.getLocalitatiPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
